/* START GENAI@GHCOPILOT */

export default function createSessionId(enableVpps?: boolean) {
  if (enableVpps) {
    /* START GENAI@GHCOPILOT */
    return crypto.randomUUID();
    /* END GENAI@GHCOPILOT */
  }

  return `vme_prod_001${Math.random().toString(36).substring(7)}`;
}
/* END GENAI@GHCOPILOT */
